import { render, staticRenderFns } from "./Winner.vue?vue&type=template&id=ce98f5b2&"
import script from "./Winner.vue?vue&type=script&lang=js&"
export * from "./Winner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports